// Browsers treat `//host`, `/\host`, and some control characters as a cross-origin URL.
const UNSAFE_PATH_CHARS = /[\u0000-\u001F\u007F\uFEFF\s\\]/;
const ROOT_RELATIVE_BASE = 'https://login.invalid';

function toRootRelativePath(path: string): string | null {
    if (!path.startsWith('/') || path.startsWith('//') || UNSAFE_PATH_CHARS.test(path)) {
        return null;
    }

    try {
        const parsed = new URL(path, ROOT_RELATIVE_BASE);
        if (parsed.origin !== ROOT_RELATIVE_BASE) {
            return null;
        }

        const rootRelative = `${parsed.pathname}${parsed.search}${parsed.hash}`;
        if (
            !rootRelative.startsWith('/') ||
            rootRelative.startsWith('//') ||
            UNSAFE_PATH_CHARS.test(rootRelative)
        ) {
            return null;
        }

        return rootRelative;
    } catch {
        return null;
    }
}

export function getGoToLocation(defaultRoute: string): string {
    const params = new URLSearchParams(window.location.search);
    const goTo = params.get('goTo');
    if (!goTo) {
        return defaultRoute;
    }

    return toRootRelativePath(goTo) ?? defaultRoute;
}
